import EN_PDF from "../../../assets/termsAndConditions/EN-terms-and-conditions.pdf"
import NO_PDF from "../../../assets/termsAndConditions/NO-terms-and-conditions.pdf"
import PL_PDF from "../../../assets/termsAndConditions/PL-terms-and-conditions.pdf"
import PageWrapper from "../../../components/PageWrapper/PageWrapper"
import UA_PDF from "../../../assets/termsAndConditions/UA-terms-and-conditions.pdf"
import arrowLeft from "../../../assets/icons/Arrows/arrow-narrow-left.png"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

const TermsAndPrivacy = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const pdfMap = {
    en: EN_PDF,
    no: NO_PDF,
    uk: UA_PDF,
    pl: PL_PDF,
  }

  const lang = (t?.i18n?.language || "en").slice(0, 2)
  const baseSrc = pdfMap[lang] || pdfMap.en
  const pdfSrc = `${baseSrc}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&view=FitH&zoom=page-width`

  return (
    <PageWrapper
      title={t("termsAndPrivacy.title")}
      headerLeft={
        <button
          className="absolute left-0 inset-y-0 my-auto w-12 h-12 flex items-center justify-center z-10"
          onClick={() => navigate(-1)}
          aria-label="Back"
        >
          <img src={arrowLeft} alt="back" className="w-6 h-6 invert" />
        </button>
      }
      background="bg-dark-default"
    >
      <div className="bg-dark-default rounded-[16px] overflow-hidden">
        <iframe
          title="terms"
          src={pdfSrc}
          className="w-full h-[80vh] bg-dark-default rounded-[16px]"
        />
      </div>
    </PageWrapper>
  )
}

export default TermsAndPrivacy
